import { Injectable } from '@angular/core';
import { NetworkService } from 'src/app/core/services/network.service';
import { DataService } from 'src/app/shared/services/data.service';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { map } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { LANGUAGES } from 'src/app/shared/languages/language';
import { TranslateService } from '@ngx-translate/core';
import { FACTORYOFFSET, NO, SELECTED_CLUSTER, SELECTED_FACTORY } from 'src/app/app.contant';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class RequesterService {
  public shiftDfosFlag: any;
  constructor(
    private networkService: NetworkService,
    private dataSer: DataService,
    private utilSer: UtilsService,
    private translate: TranslateService,
    private datePipe: DatePipe
  ) {

  }

  getfactoryIdData() {
    return {
      factoryId: this.dataSer.getStorageData('selectedFactory') ?
        JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null,
    };
  }

  getFactoryNameData() {
    return {
      factoryname: this.dataSer.getStorageData('selectedFactory') ?
        JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null,
    };
  }

  public deleteLineShiftConfiguration(data: any) {
    return this.networkService.httpReq('delete', 'SPCAPI', 'DeleteLineShiftConfiguration', data, false);
  }

  public getFactoryOffset(): number {
    const obj: any = sessionStorage.getItem(FACTORYOFFSET);
    return obj ? parseInt(obj, 10) / 1000 : 0;
  }

  public getLinesShifts(factoryType: any, lineList: any) {
    const data = factoryType ? factoryType : {};
    const offsetValue: number = this.getFactoryOffset();
    return this.networkService.httpReq('get', 'SPCAPI', 'GetLineShifts', data, false).pipe(map((res: any) => {
      if (res && res.length > 0) {
        res.forEach((el: any, i: number) => {
          el.srNo = i + 1;
          const line = lineList.find((l: any) => l.id === el.lineId);
          el.linename = line ? line.linename : el.lineId;
          const sd = new Date(el.startDate);
          const ed = new Date(el.endDate);
          const sEpoch: any = this.utilSer.timeStampConverter(el.startTimeEpoch * 1000, false);
          const eEpoch: any = this.utilSer.timeStampConverter(el.endTimeEpoch * 1000, false);
          // const sEpoch: any = offsetValue > 0 ? el.startDate : this.utilSer.timeStampConverter(el.startTimeEpoch * 1000, true);
          // const eEpoch: any = offsetValue > 0 ? el.endDate : this.utilSer.timeStampConverter(el.endTimeEpoch * 1000, false);
          el.startDate = this.utilSer.formatDateMonDDYYYY(sEpoch);
          el.endDate = ed < sd ? '' : this.utilSer.formatDateMonDDYYYY(eEpoch);
        });
        return res;
      }
      return [];
    }));
  }
  public getLinesShiftsAlert(lineIds) {
    let factoryId = this.dataSer.getStorageData('selectedFactory') ?
      JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null;
    const data = { factoryId: factoryId, lineIds: lineIds };

    return this.networkService.httpReq('get', 'SPCAPI', 'GetLineShifts', data, false).pipe(map((res: any) => {
      if (res && res.length > 0) {

        return res;
      }
      return [];
    }));
  }

  public addShiftDetails(payload?: any) {
    return this.networkService.httpReq('post', 'SPCAPI', 'AddShiftConfiguration', payload, false);
  }

  public getLines(type?: any, param?: any, ForceWriteDB: string = 'No') {
    if (type === 'dfos') {
      const dfosClusterId = this.dataSer.getStorageData('selectedCluster') ?
        JSON.parse(this.dataSer.getStorageData('selectedCluster')).clusterId : null;
      const dfosFactoryId = this.dataSer.getStorageData('selectedFactory') ?
        JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null;
      if (dfosClusterId) {
        return this.networkService.httpReq('get', 'SPCAPI', 'GetDfosLines', { factoryId: dfosFactoryId }, false).pipe(map(
          data => this.dataSer.processLineResp(data)
        ));
      }
    } else {
      const data: any = param ? param : {};
      data.ForceWriteDB = ForceWriteDB;
      if (type === 'GA') {
        data.factoryname = this.dataSer.getStorageData('selectedFactory') ?
          JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null;
        data.type = type;
      } else {
        data.factoryname = this.dataSer.getStorageData('selectedFactory') ?
          JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null;
      }

      return this.networkService.httpReq('get', 'SPCAPI', 'GetLines', data, false);
    }
  }

  public getDfosSku(lineDtls: any) {
    const dfosClusterId = this.dataSer.getStorageData('selectedCluster') ?
      JSON.parse(this.dataSer.getStorageData('selectedCluster'))._id.$oid : null;
    const dfosFactoryId = this.dataSer.getStorageData('selectedFactory') ?
      JSON.parse(this.dataSer.getStorageData('selectedFactory'))._id.$oid : null;
    return this.networkService.httpReq('get', 'dfos', 'regions/' + dfosClusterId + '/factories/' + dfosFactoryId + '/lines/' +
      lineDtls.dfosid, false).pipe(map(
        data => this.dataSer.processSkuResp(data)
      ));
  }

  public updateLine(data: any, islocalName = false, skuMdUpdateMethod) {
    const req: any = {};
    req.factoryname = this.dataSer.getStorageData('selectedFactory') ?
      JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null;
    req.region = this.dataSer.getStorageData('selectedCluster') ?
      JSON.parse(this.dataSer.getStorageData('selectedCluster')).clusterId : null;
    req.regionrname = this.dataSer.getStorageData('selectedCluster') ?
      JSON.parse(this.dataSer.getStorageData('selectedCluster')).name : null;
    req.Area = data.area.name;
    req.Type = data.area.id === 'dfos' && data.dfoslinked ? 'DfosLine' : 'Manual';
    req.dfoslineid = data.area.id === 'dfos' ? data.linename.dfosLineId : undefined;
    req.linename = data.area.id === 'dfos' ? data.linename.name : data.linename;
    // if (islocalName) {
    //   req.linename = data.area.id === 'dfos' ? data.linename.localName : data.linename;
    // }
    req.factory = data.area.id === 'dfos' ? (this.dataSer.getStorageData('selectedFactory') ?
      JSON.parse(this.dataSer.getStorageData('selectedFactory')).name : null) : undefined;
    req.sapcode = data.area.id === 'dfos' ? data.linename.sapCode : undefined;
    req.skutagname = data.skutag ? data.skutag.trim() : null;
    req.description = data.description;
    req.DfosId = data.area.id === 'dfos' ? data.linename.lineId : undefined;
    req.DfosVersion = data.area.id === 'dfos' ? data.linename.dfosVersion : undefined;
    req.DfosActive = data.dfoslinked;
    req.dfosformatOrSkuBased = skuMdUpdateMethod;
    req.spcformatOrSkuBased = data.spcformatOrSkuBased;

    if (data.productTechnology.ProductTechnologyId === 'other') {
      data.productTechnology.ProductTechnologyName = data.customproductTechnology;
      data.productTechnology.ProductTechnologyId = '';
    }
    if (data?.processingCategory?.ProcessingCategoryId === 'other') {
      data.processingCategory['ProcessingCategoryName'] = data.customprocessingCategory;
      data.processingCategory['ProcessingCategoryId'] = '';
    }
    if (data?.packagingCategory?.PackingCategoryId === 'other') {
      data.packagingCategory['PackingCategoryName'] = data.custompackagingCategory;
      data.packagingCategory['PackingCategoryId'] = '';
    }
    req.producttechnologyname = data.productTechnology.ProductTechnologyName;
    req.producttechnologyid = data.productTechnology.ProductTechnologyId;
    req.processingcategoryname = data?.processingCategory?.ProcessingCategoryName ? data?.processingCategory?.ProcessingCategoryName : '';
    req.processingcategoryid = data?.processingCategory?.ProcessingCategoryId ? data?.processingCategory?.ProcessingCategoryId : '';
    req.packingcategoryname = data?.packagingCategory?.PackingCategoryName ? data?.packagingCategory?.PackingCategoryName : '';
    req.packingcategoryid = data?.packagingCategory?.PackingCategoryId ? data?.packagingCategory?.PackingCategoryId : '';
    req.bgfactorymappingid = data?.bg?.bgfactorymappingid ? data?.bg?.bgfactorymappingid : '';
    req.bgname = data?.bg?.bgname ? data?.bg?.bgname : '';
    if (data.lineid) {
      req.id = data.lineid;
    }

    if (data.dailyCheck && data.shiftCheck) {
      req.managerEmailMode = 'both';
    } else if (data.dailyCheck) {
      req.managerEmailMode = 'daily';
    } else if (data.shiftCheck) {
      req.managerEmailMode = 'shift';
    } else {
      req.managerEmailMode = 'none';
    }

    const emailAlertContacts: any[] = [];

    if (data.emailList && data.emailList.trim()) {
      emailAlertContacts.push({
        mode: 'operator',
        emailIds: data.emailList.split(',').map((e: string) => e.trim()).filter((e: string) => e)
      });
    }

    if (data.dailyCheck && data.dailyEmailList && data.dailyEmailList.trim()) {
      emailAlertContacts.push({
        mode: 'daily',
        emailIds: data.dailyEmailList.split(',').map((e: string) => e.trim()).filter((e: string) => e)
      });
    }

    if (data.shiftCheck && Array.isArray(data.shiftArray)) {
      data.shiftArray.forEach((shiftItem: any) => {
        if (shiftItem.shiftEmails && shiftItem.shiftManagerAMPM) {
          const shiftObj = shiftItem.shiftManagerAMPM;
          const shiftCode = typeof shiftObj === 'object' ? shiftObj.code : null;
          const shiftName = typeof shiftObj === 'object' ? shiftObj.value : shiftObj;

          emailAlertContacts.push({
            mode: 'shift',
            shiftCode: shiftCode,
            shiftTrigger: shiftName,
            emailIds: shiftItem.shiftEmails.split(',').map((e: string) => e.trim()).filter((e: string) => e)
          });
        }
      });
    }

    req.emailAlertContacts = emailAlertContacts;

    // console.log('Request Data: ', req)
    // return null;
    return this.networkService.httpReq('post', 'SPCAPI', 'Addline', req, false);
  }

  public deleteLine(data: any) {
    return this.networkService.httpReq('delete', 'SPCAPI', 'DeleteLine', data, false);
  }

  getMachines(siteId, param?: any, ForceWriteDB: string = 'No') {
    const data: any = param ? param : {};
    data.ForceWriteDB = ForceWriteDB;
    data.factoryname = this.dataSer.getStorageData('selectedFactory') ?
      JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null;
    return this.networkService.httpReq('get', 'SPCAPI', 'GetMachines', data, false);
  }

  addMachine(machineDtls) {
    const data: any = {
      machinename: machineDtls.machineName,
      MachineStatusTag: machineDtls.machineStatusTag,
      description: machineDtls.description ? machineDtls.description : '',
      linename: machineDtls.line.linename,
      lineid: machineDtls.line.id,
      region: this.dataSer.getStorageData('selectedCluster') ?
        JSON.parse(this.dataSer.getStorageData('selectedCluster')).clusterId : null,
      factoryname: this.dataSer.getStorageData('selectedFactory') ?
        JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null,
    };

    if (machineDtls.id) {
      // edit mode
      data.id = machineDtls.id;
    }

    return this.networkService.httpReq('post', 'SPCAPI', 'AddMachine', data, false);
  }

  deleteMachine(machineDtls) {
    const data: any = {
      machineid: machineDtls.id,
      factoryname: this.dataSer.getStorageData('selectedFactory') ?
        JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null,
    };
    return this.networkService.httpReq('delete', 'SPCAPI', 'DeleteMachine', data, false);
  }

  getParameter() {
    return this.networkService.httpReq('get', 'SPCAPI', 'GetParameters', this.getFactoryNameData(), false);
  }

  getParameterByMachine(machineId: any, ForceWriteDB: string = NO) {
    const data = {
      factoryname: this.dataSer.getStorageData('selectedFactory') ?
        JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null,
      machineid: machineId,
      ForceWriteDB
    };
    return this.networkService.httpReq('get', 'SPCAPI', 'GetParameters', data, false);
  }


  addParameter(addParamData, factoryData, egaData?: any, skudata?: any, allsku?: any) {
    ///debugger;

    // Mutate skudata in-place if batch is true or 1
    if ((addParamData.batch === true || addParamData.batch === 1) && skudata && skudata.length > 0) {
      skudata.forEach(sku => {
        sku.skutarget = "0";
        sku.tolerance = sku.tolerance ? String(sku.tolerance) : "0";
      });
    }

    const isBatchMode = addParamData.batch === true || addParamData.batch === 1;

    const data: any = {
      parametername: addParamData.parameterName,
      classification: addParamData.classification,
      usl: (skudata === null || skudata.length === 0) ? (isBatchMode ? null : allsku.skuusl) : '1',
      lsl: (skudata === null || skudata.length === 0) ? (isBatchMode ? null : allsku.skulsl) : '2',
      targetvalue: (skudata === null || skudata.length === 0) ? (isBatchMode ? null : allsku.skutarget) : '2',
      tolerance: (skudata === null || skudata.length === 0) ? (isBatchMode ? (allsku?.tolerance ? String(allsku.tolerance) : null) : null) : null,
      unit: addParamData.parameterUnit.label,
      alert: addParamData.alert === true ? '1' : '0',
      batch: (addParamData.batch === true || addParamData.batch === 1) ? 'Yes' : 'No',
      tagname: addParamData.tagName,
      tagsku: skudata === null || skudata.length === 0 ? 'No' : 'Yes',
      lineid: addParamData.line.id,
      linename: addParamData.line.linename,
      machineid: addParamData.machine.id,
      machinename: addParamData.machine.machinename,
      bgbu_parametertype: addParamData.bgbu_parametertype?.parametertype || null,
      bgbu_guid: addParamData.bgbu_parametertype?.BgBu_Guid || null,
      region: this.dataSer.getStorageData('selectedCluster') ?
        JSON.parse(this.dataSer.getStorageData('selectedCluster')).clusterId : null,
      factoryname: this.dataSer.getStorageData('selectedFactory') ?
        JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null,
      ParameterType: addParamData.parameterType,
      DataSource: addParamData.dataSource,
      samplingvalue: addParamData.time || undefined,
      type: egaData?.type || '',
      giveAway: egaData?.giveAway || undefined,
      TypeofParam: addParamData.TypeofParam || null,
    };

    if (skudata && skudata.length > 0) {
      data.SKU = skudata;
      data.skuFormatInfo = skudata.map(e => ({
        skuid: e.skuid,
        skuformat: e.skuname,
        skulsl: isBatchMode ? null : e.skulsl,
        skutarget: isBatchMode ? "0" : e.skutarget,
        skuusl: isBatchMode ? null : e.skuusl,
        tolerance: isBatchMode ? (e.tolerance ? String(e.tolerance) : "0") : null,
        validator: true
      }));
    }


    if (addParamData.line?.spcformatOrSkuBased === "Format Based") {
      data.formatorsku = addParamData.formatorsku || (
        (data.skuFormatInfo?.length > 0 ||
          addParamData.line?.spcformatOrSkuBased === "Format Based") &&
          factoryData?.length > 0
          ? "Format Based"
          : "Sku Based"
      );
    }
    else {
      data.formatorsku = "Sku Based"


    }


    if (addParamData.skuid) {
      data.id = addParamData.skuid;
    }

    // console.log("Payload: ", data);

    return this.networkService.httpReq('post', 'SPCAPI', 'AddParameters', data, false);
  }
  public updateSKU(data: any) {
    const req: any = {
      // isrecipe: data.isrecipe,
      barcode: data.barcode,
      description: data.description,
      skucode: data.skuname,
      factoryname: this.dataSer.getStorageData('selectedFactory') ?
        JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null,
      region: this.dataSer.getStorageData('selectedCluster') ?
        JSON.parse(this.dataSer.getStorageData('selectedCluster')).clusterId : null
    };
    if (data.skuuniqueid) {
      // edit mode
      req.id = data.skuuniqueid;
    }
    return this.networkService.httpReq('post', 'SPCAPI', 'AddSku', req, false);
  }

  public deleteSKU(data: any) {
    return this.networkService.httpReq('post', 'SPCAPI', 'DeleteSku', data, false);
  }

  public lMBulkUpload(file: any, type: any) {
    const payload: any = new FormData();
    const filename = type === 'line' ? 'linefile' : 'machinefile';
    payload.append('regionrname', this.dataSer.getStorageData('selectedCluster') ?
      JSON.parse(this.dataSer.getStorageData('selectedCluster')).name : null);
    payload.append('region', this.dataSer.getStorageData('selectedCluster') ?
      JSON.parse(this.dataSer.getStorageData('selectedCluster')).clusterId : null);
    payload.append('factoryname', this.dataSer.getStorageData('selectedFactory') ?
      JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null);
    payload.append(filename, file, file.name);
    const hitURL = type === 'line' ? 'LineBulkUpload' : 'MachineBulkUpload';
    return this.networkService.httpReq('post', 'SPCAPI', hitURL, payload, true);
  }

  public bgBuBulkUpload(file: any, type: any) {
    const payload: any = new FormData();

    payload.append('regionrname', this.dataSer.getStorageData('selectedCluster') ?
      JSON.parse(this.dataSer.getStorageData('selectedCluster')).name : null);
    payload.append('region', this.dataSer.getStorageData('selectedCluster') ?
      JSON.parse(this.dataSer.getStorageData('selectedCluster')).clusterId : null);
    payload.append('factoryname', this.dataSer.getStorageData('selectedFactory') ?
      JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null);
    payload.append('bgbufile', file, file.name);
    return this.networkService.httpReq('post', 'SPCAPI', 'bgbubulkupload', payload, true);
  }

  public skuBulkUpload(file: any) {
    const payload: any = new FormData();
    payload.append('region', this.dataSer.getStorageData('selectedCluster') ?
      JSON.parse(this.dataSer.getStorageData('selectedCluster')).clusterId : null);
    payload.append('factoryname', this.dataSer.getStorageData('selectedFactory') ?
      JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null);
    payload.append('skufile', file, file.name);
    return this.networkService.httpReq('post', 'SPCAPI', 'SkuBulkUpload ', payload, true);
  }

  public parameterBulkUpload(doc: any) {
    const payload: any = new FormData();
    payload.append('region', this.dataSer.getStorageData('selectedCluster') ?
      JSON.parse(this.dataSer.getStorageData('selectedCluster')).clusterId : null);
    payload.append('factoryname', this.dataSer.getStorageData('selectedFactory') ?
      JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null);
    payload.append('paramfile', doc, doc.name);
    return this.networkService.httpReq('post', 'SPCAPI', 'ParameterBulkUpload  ', payload, true);
  }

  public giveAwayBulkUpload(doc: any) {
    const payload: any = new FormData();
    payload.append('Offset', this.dataSer.getStorageData('factoryOffset') ?
      JSON.parse(this.dataSer.getStorageData('factoryOffset')) : null);
    payload.append('region', this.dataSer.getStorageData('selectedCluster') ?
      JSON.parse(this.dataSer.getStorageData('selectedCluster')).clusterId : null);
    payload.append('factoryname', this.dataSer.getStorageData('selectedFactory') ?
      JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null);
    payload.append('paramfile', doc, doc.name);
    return this.networkService.httpReq('post', 'SPCAPI', 'GiveAwayBulkUpload  ', payload, true);
  }

  public deleteParameter(paramList: any) {
    const data: any = {
      factoryname: this.dataSer.getStorageData('selectedFactory') ?
        JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null,
      parameter: paramList
    };
    return this.networkService.httpReq('delete', 'SPCAPI', 'DeleteParameter', data, true);
  }

  getAlerts(ForceWriteDB: string = NO) {
    const data = { ...this.getfactoryIdData(), ForceWriteDB };
    return this.networkService.httpReq('get', 'SPCAPI', 'GetEmailSmsAlertList', data, false);
  }

  addAlert(value) {
    const hour = new Date(value.interval).getHours();
    const min = new Date(value.interval).getMinutes();
    const hoursMinutes = hour * 60 + min;
    const data: any = {
      AlertName: value.alertName,
      LineId: value.line.id,
      LineName: value.line.linename,
      Rule1: value.rule1,
      Rule6: value.rule6,
      Rule7: value.rule7,
      RuleLslUsl: value.lslUsl,
      AA: value.aa,
      A: value.a,
      B: value.b,
      C: value.c,
      TimeInterval: hoursMinutes,
      factoryId: this.dataSer.getStorageData('selectedFactory') ?
        JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null,
      ManagerAMPM: value.DailyAMPM,
      DirectorAMPM: null,
      EmailAlertContacts: []
    };
    if (value.sms) {
      data.SmsList = value.smsList.split(',');
    }
    if (value.email) {
      data.EmailList = value.emailList.split(',');
      data.EmailAlertContacts.push({
        "EscalationLevel": "0",
        "EmailIds": value.emailList.split(','),
        "TimeInterval": hoursMinutes
      });
    }

    if (value.dailyCheck) {
      data.EmailAlertContacts.push({
        "EscalationLevel": "1",
        "EmailIds": value.dailyEmailList.split(','),
        "Mode": "daily",
        "DailyEmailTriggerTime": value.dailyEscalationTime,
        "DailyEmailTriggerAMPM": value.DailyAMPM,
      })
      data.managerEmailMode = 'daily';
    }

    if (value.shiftCheck) {
      value.shiftArray.forEach(value => {
        data.EmailAlertContacts.push({
          "EscalationLevel": "1",
          "EmailIds": value.shiftEmails.split(','),
          "Mode": "shift",
          "ShiftNo": value.shiftManagerAMPM.code
        })
      });
      data.managerEmailMode = 'shift';
    }
    if (value.dailyCheck && value.shiftCheck) {
      data.managerEmailMode = 'both';
    } else if (!value.dailyCheck && !value.shiftCheck) {
      data.managerEmailMode = null;
    }


    const parametrs = [];
    value.parameter.forEach(element => {
      const param = {
        parameterName: element.parametername,
        classificationName: element.classification,
        machineName: element.machinename,
        parameterID: element.id,
        machineID: element.machineid
      };
      parametrs.push(param);
    });
    data.ClassificationList = parametrs;
    const machines = [];
    value.machine.forEach(element => {
      machines.push(element.id);
    });
    data.MachineList = machines;
    if (value.id) {
      data.id = value.id;
    }

    return this.networkService.httpReq('post', 'SPCAPI', 'InsertEmailSmsAlertData', data, false);
  }

  deleteAlert(alertDtls) {
    const data: any = {
      id: alertDtls.id,
      factoryId: this.dataSer.getStorageData('selectedFactory') ?
        JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null,
    };
    return this.networkService.httpReq('delete', 'SPCAPI', 'DeleteEmailSmsAlert?Id=' + data.id + '&factoryId=' + data.factoryId, false);
  }

  GetSkuRunList(ForceWriteDB = NO) {
    const data: any = { ...this.getfactoryIdData(), ForceWriteDB };
    return this.networkService.httpReq('get', 'SPCAPI', 'GetSkuRunList', data, false);
  }

  addSKURun(skudetails: any) {
    const cluster: any = this.dataSer.getStorageData(SELECTED_CLUSTER);
    const factory: any = this.dataSer.getStorageData(SELECTED_FACTORY);
    const sTime = new Date(skudetails.startTime);
    sTime.setSeconds(0);
    sTime.setMilliseconds(0);
    const StartTime = sTime.getTime();
    const eTime = new Date(skudetails.endTime);
    eTime.setSeconds(59);
    eTime.setMilliseconds(0);
    const EndTime = eTime.getTime();
    const data: any = {
      region: cluster ? JSON.parse(cluster).clusterId : null,
      factoryId: factory ? JSON.parse(factory).factoryId : null,
      DfosfactoryId: factory ? JSON.parse(factory).factoryId : null,
      LineId: skudetails.line.id,
      LineName: skudetails.line.linename,
      SkuName: skudetails.sku.skucode,
      SkuId: '' + skudetails.sku.id,
      StartTimeEpoch: Math.floor(this.utilSer.timeStampConverter(StartTime) / 1000),
      EndTimeEpoch: skudetails.endTime ? Math.floor(this.utilSer.timeStampConverter(EndTime) / 1000) : undefined,
      OverrideSkuRun: skudetails.override ? skudetails.override : false
    };
    if (skudetails.id) {
      data.Id = skudetails.id;
      return this.networkService.httpReq('post', 'SPCAPI', 'InsertSkuRunData', data, false);
    } else {
      return this.networkService.httpReq('post', 'SPCAPI', 'InsertSkuRunData', data, false);
    }
  }

  GetCurrentRunningSku(skuformdtls) {
    const data: any = {
      factoryId: this.dataSer.getStorageData('selectedFactory') ?
        JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null,
      LineId: skuformdtls.line.id,
      SkuId: skuformdtls?.id,
      StartTimeEpoch: Math.floor(this.utilSer.timeStampConverter(skuformdtls.startTime) / 1000),
      EndTimeEpoch: skuformdtls.endTime !== undefined ? Math.floor(this.utilSer.timeStampConverter(skuformdtls.endTime) / 1000) : 0

    };
    return this.networkService.httpReq('get', 'SPCAPI', 'GetCurrentRunningSku', data, false);
  }

  onlineSave(userdtls, manualentryList, type, uploadType = 'sensor') {
    const selectedCluster = this.dataSer.getStorageData('selectedCluster');
    const selectedFactory = this.dataSer.getStorageData('selectedFactory');
    const selectedClusterParse = selectedCluster ? JSON.parse(selectedCluster) : null;
    const selectedFactoryParse = selectedFactory ? JSON.parse(selectedFactory) : null;
    const data: any = [];
    const data1: any = {
      Id: (type === 'save' && manualentryList && manualentryList.id) ? manualentryList.id : (type === 'submit') ? undefined : '',
      UserId: userdtls.username,
      UserName: userdtls.name, // + ' ' + userdtls.profile.family_name,
      regionName: selectedClusterParse ? selectedClusterParse.name : null,
      FactoryName: selectedFactoryParse ? selectedFactoryParse.name : null,
      region: selectedClusterParse ? selectedClusterParse.clusterId : null,
      FactoryId: selectedFactoryParse ? selectedFactoryParse.factoryId : null,
      SiteId: selectedFactoryParse ? (selectedFactoryParse.siteId ? selectedFactoryParse.siteId : (selectedFactoryParse.site ? selectedFactoryParse.site : null)) : null,
      LineName: manualentryList ? manualentryList.line.linename : '',
      MachineName: manualentryList && manualentryList.machine ? manualentryList.machine.machinename : '',
      ParameterName: manualentryList ? manualentryList.parameter.parametername : '',
      LineId: manualentryList ? manualentryList.line.id : manualentryList,
      MachineId: manualentryList ? manualentryList.machine.id : '',
      ParameterId: manualentryList ? manualentryList.parameter.id : '',
      SkuName: manualentryList ? manualentryList.sku.skuname : '',
      SkuId: manualentryList ? manualentryList.sku.skuid : '',
      Date: type === 'save' ? Math.floor(this.utilSer.timeStampConverter(manualentryList.time) / 1000) : undefined,
    };
    const points = [];
    if (type === 'save') {
      manualentryList.points.forEach(element => {
        const item1 = {
          TTMM: element.time,
          TSEpoch: undefined,
          Value: element.pvalue,
          Comments: element.comment
        };
        points.push(item1);
      });
    } else {
      manualentryList.points.forEach(element => {
        const item1 = {
          TTMM: undefined,
          TSEpoch: Math.floor(this.utilSer.timeStampConverter(new Date(
            manualentryList.time.toString().substring(0, 16) + element.time + ':00' + manualentryList.time.toString().substring(24)
          )) / 1000),
          Value: element.pvalue,
          Comments: element.comment
        };
        points.push(item1);
      });
    }
    (type === 'save') ? data1.Datapoints = points : data1.SensorDataCollections = points;
    data.push(data1);
    const endUrl = (type === 'submit') ? 'OnlineSensorCollectionSubmit' : 'SaveSensorDataManually';
    const finalUrl = uploadType === 'sensor' ? endUrl : (type === 'submit') ? 'OnlineBatchCollectionSubmit' : 'SaveBatchDataManually';
    return this.networkService.httpReq('post', 'SPCAPI', finalUrl, data, false);
  }

  public onlineSaveBatch(userdtls, manualentryList, type) {
    const selectedCluster = this.dataSer.getStorageData('selectedCluster');
    const selectedFactory = this.dataSer.getStorageData('selectedFactory');
    const clusterParse = selectedCluster ? JSON.parse(selectedCluster) : null;
    const factoryParse = selectedFactory ? JSON.parse(selectedFactory) : null;
    const data: any = [];
    const data1: any = {
      Id: (type === 'save' && manualentryList.id) ? manualentryList.id : (type === 'submit') ? undefined : '',
      UserId: userdtls ? (userdtls.username || userdtls.userName) : undefined,
      UserName: userdtls.name, // + ' ' + userdtls.profile.family_name,
      regionName: clusterParse ? clusterParse.name : null,
      FactoryName: factoryParse ? factoryParse.name : null,
      region: clusterParse ? clusterParse.clusterId : null,
      FactoryId: factoryParse ? factoryParse.factoryId : null,
      SiteId: factoryParse ? (factoryParse.siteId ? factoryParse.siteId : factoryParse.site ? factoryParse.site : null) : null,
      LineName: manualentryList.line.linename,
      MachineName: manualentryList.machine.machinename,
      ParameterName: manualentryList.parameter.parametername,
      LineId: manualentryList.line.id,
      MachineId: manualentryList.machine.id,
      ParameterId: manualentryList.parameter.id,
      SkuName: manualentryList.sku.skuname,
      SkuId: manualentryList.sku.skuid,
      Date: type === 'save' ? this.datePipe.transform(new Date(), 'y-MM-d hh:mm:ss') : undefined,
    };
    const points = [];
    if (manualentryList.points && manualentryList.points.length > 0) {
      if (manualentryList.points) {
        manualentryList.points.forEach((element: any) => {
          const item1 = {
            Batch: element.batch,
            Comments: element.comment,
            Day: '1',
            TSEpoch: Math.floor(this.utilSer.timeStampConverter(new Date(
              element.dates)) / 1000), // in epoch format
            Value: element.pvalue,
            TTMM: element.time,
            SetPoint: element.setPoints,
            Shift: element.shift
          };
          points.push(item1);
        });
      }
    }
    (type === 'save') ? data1.Datapoints = points : data1.BatchDataCollections = points;
    data.push(data1);
    const endUrl = (type === 'submit') ? 'OnlineBatchCollectionSubmit' : 'SaveBatchDataManually';
    return this.networkService.httpReq('post', 'SPCAPI', endUrl, data, false);
  }

  draftFilter(manualentry) {
    const data: any = {
      lineid: manualentry.line.id,
      machineid: manualentry.machine.id,
      parameterid: manualentry.parameter.id,
      skuid: manualentry.sku.skuid,
      factoryid: this.dataSer.getStorageData('selectedFactory') ?
        JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null,
    };
    const url = manualentry.type === 'Continous' ? 'GetSavedSensorDataManually' : 'GETSavedBatchDataManually';
    return this.networkService.httpReq('get', 'SPCAPI', url, data, false).pipe(map((res: any) => {
      if (res && res.draftData && res.draftData.length && manualentry.type === 'Batch') {
        res.draftData.forEach((element: any) => {
          if (element.Datapoints && element.Datapoints.length) {
            element.Date = element.Datapoints[0].TSEpoch;
          }
        });
      }
      return res;
    }));
  }

  public GetMasterTemplate(name, IsMaster) {
    const data: any = { filename: name, masterModule: IsMaster };
    return this.networkService.httpReq('getBlob', 'SPCAPI', 'GetMasterTemplate', data, false);
  }
  deleteSubmittedRec(recID, isBatch = false) {
    const data: any = {
      FactoryId: this.dataSer.getStorageData('selectedFactory') ?
        JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null,
      id: recID
    };
    const url = isBatch ? 'DeleteSavedBatchDataManually' : 'DeleteSavedSensorDataManually';
    return this.networkService.httpReq('delete', 'SPCAPI', url, data, false);
  }

  addManualEntry(uploadType, userdtls, manualentry?, file?: any, pType?: string) {
    const selectedCluster = this.dataSer.getStorageData('selectedCluster');
    const selectedFactory = this.dataSer.getStorageData('selectedFactory');
    const factoryrParse = selectedFactory ? JSON.parse(selectedFactory) : null;
    const clusterParse = selectedCluster ? JSON.parse(selectedCluster) : null;
    if (uploadType === '2' || uploadType === 2) {
      const data: any = {
        Tag: manualentry.parameter ? manualentry.parameter.tagname : '',
        TSEpoch: Math.floor(this.utilSer.timeStampConverter(manualentry.time) / 1000),
        Value: manualentry.value,
        Comment: manualentry.comment ? manualentry.comment : undefined,
        UserId: userdtls.username,
        UserName: userdtls.name, //.given_name + ' ' + userdtls.profile.family_name,
        regionName: clusterParse ? clusterParse.clusterId : null,
        FactoryName: factoryrParse ? factoryrParse.factoryId : null,
        SiteId: factoryrParse ? factoryrParse.siteId ? factoryrParse.siteId : factoryrParse.site ? factoryrParse.site : null : null,
      };
      const url = pType === 'batch' ? 'ManualBatchBulkUpload' : 'UploadQualityParametersForTimeSeriesChart';
      return this.networkService.httpReq('post', 'SPCAPI', url, data, false);
    } else {
      const payload: any = new FormData();
      payload.append('Offset', this.dataSer.getStorageData('factoryOffset') ?
        JSON.parse(this.dataSer.getStorageData('factoryOffset')) : null);
      payload.append('UserId', userdtls.username);
      payload.append('UserName', userdtls.name /*profile.given_name + ' ' + userdtls.profile.family_name*/);
      const fileParam = pType === 'batch' ? 'manualbatchfile' : 'manualsensorfile';
      payload.append(fileParam, file, file ? file.name : '');
      payload.append('factoryname', factoryrParse ? factoryrParse.factoryId : null);
      payload.append('regionName', clusterParse ? clusterParse.clusterId : null);
      payload.append('SiteId', factoryrParse ? factoryrParse.siteId ? factoryrParse.siteId : factoryrParse.site ? factoryrParse.site : null : null);
      const url = pType === 'batch' ? 'ManualBatchBulkUpload' : 'UploadQualityParametersForTimeSeriesChart';
      return this.networkService.httpReq('post', 'SPCAPI', url, payload, true);
    }
  }

  // bulk upload factory onboarding
  public factoryOnboardBulkUpload(file: any) {
    const payload: any = new FormData();
    payload.append('factoryfile', file, file.name);
    const hitURL = 'FactoryBulkUpload';
    return this.networkService.httpReq('post', 'SPCAPI', hitURL, payload, true);
  }

  public updateFactory(data: any) {
    const req: any = {};
    req.factoryid = data.factoryid;
    req.factoryname = data.factoryname;
    req.offset = data.offset;
    req.siteid = data.siteid;
    req.isformatbasedfactory = data.isformatbasedfactory;
    if (data.id) {
      req.id = data.id;
    }
    return this.networkService.httpReq('post', 'SPCAPI', 'AddFactory', req, false);
  }

  getFactories() {
    return this.networkService.httpReq('get', 'SPCAPI', 'GetFactories', '', false);
  }

  deleteFactory(obj) {
    const data: any = {
      id: obj.id,
      factoryid: obj.factoryid
    };
    return this.networkService.httpReq('delete', 'SPCAPI', 'DeleteFactory', data, false);
  }

  public AddPowerBiReportUrl(payload?: any) {
    return this.networkService.httpReq('post', 'SPCAPI', 'AddPowerBiReportUrl', payload, false);
  }


  getReportsUsers() {
    return this.networkService.httpReq('get', 'SPCAPI', 'InsertPowerBIUser', '', false);
  }

  // addReportsUser(payload?: any) {
  //   return this.networkService.httpReq('post', 'SPCAPI', 'InsertPowerBIUser', payload, false);
  // }

  addReportsUser(email: string) {
    const body = {
      factoryid: this.dataSer.getStorageData('selectedFactory') ?
        JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null,
      region: this.dataSer.getStorageData('selectedCluster') ?
        JSON.parse(this.dataSer.getStorageData('selectedCluster')).clusterId : null,
      userid: email,
      userrole: 'spc-Support'

    };
    return this.networkService.httpReq('post', 'SPCAPI', 'InsertPowerBIUser', body, false);
  }
  GetBGList() {
    return this.networkService.httpReq('get', 'SPCAPI', 'GetBGList', '', false);
  }
  GetProductTechnologyById(data) {
    return this.networkService.httpReq('get', 'SPCAPI', 'GetProductTechnologyById', data, false);
  }
  GetProcessingCategoryById(data) {
    return this.networkService.httpReq('get', 'SPCAPI', 'GetProcessingCategoryById', data, false);
  }
  GetPackingCategoryById(data) {
    return this.networkService.httpReq('get', 'SPCAPI', 'GetPackingCategoryById', data, false);
  }
  GetBgBuConfig(factoryId = '', lineid = '') {
    const data = {
      factoryid: factoryId,
      lineid: lineid
    }
    if (factoryId) {
      return this.networkService.httpReq('get', 'SPCAPI', 'GetBgBuConfig', data, false);
    } else {
      return this.networkService.httpReq('get', 'SPCAPI', 'GetBgBuConfig', '', false);
    }
  }
  AddBgConfig(payload?: any) {
    if (payload.BgBu_Guid) {
      return this.networkService.httpReq('post', 'SPCAPI', 'updatebgbuconfig', payload, false);
    } else {
      return this.networkService.httpReq('post', 'SPCAPI', 'AddBgConfig', payload, false);
    }
  }

  DeleteBGBUConfig(Dtls) {
    const data: any = {
      BgBu_Guid: Dtls.BgBu_Guid
    };
    return this.networkService.httpReq('delete', 'SPCAPI', 'DeleteBGBUConfig', data, false);
  }
  GetProcessingCategoryByFactory(data) {
    return this.networkService.httpReq('get', 'SPCAPI', 'GetProcessingCategoryByFactory', data, false);
  }
  GetProductTechnologyByFactory(data) {
    return this.networkService.httpReq('get', 'SPCAPI', 'GetProductTechnologyByFactory', data, false);
  }
  GetPackingCategoryByFactory(data) {
    return this.networkService.httpReq('get', 'SPCAPI', 'GetPackingCategoryByFactory', data, false);
  }

  GetBusinessGroupByFactory(data) {
    return this.networkService.httpReq('get', 'SPCAPI', 'GetBusinessGroupByFactory', data, false);
  }
  addciadxconfig(data: any, dates: any, useCase, flag: boolean) {
    console.log("Add USECASE: ", useCase)
    let offset = sessionStorage.getItem('factoryOffset') ? JSON.parse(sessionStorage.getItem('factoryOffset')) : 0;
    const req: any = {
      usecase_id: useCase.useCaseId,
      training_data_start_dt: offset > 19800000 ? Math.floor(dates.convertedFrom + 86400) : Math.floor(dates.convertedFrom), // if offset more that 5:30 gmt then add extra day else same (86400 - 1 day)
      // training_data_start_dt: Math.floor(dates.convertedFrom), // new Date(dates.convertedFrom).toUTCString(),
      // training_data_end_dt: offset > 19800000 ? Math.floor(dates.convertedTo + 86400 + 86398) : Math.floor(dates.convertedTo + 86398), // // if offset more that 5:30 gmt then add extra day else same
      training_data_end_dt: Math.floor(dates.convertedTo),
      forecast_interval: data.forecastInterval,
      factoryid: this.dataSer.getStorageData('selectedFactory') ?
        JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null,
      linemasterid: useCase.lineMasterId || useCase.linemasterid,
      skumasterid: useCase.skumasterId || useCase.skumasterid,
      target_parametermasterid: useCase.target_parametermasterid || useCase.targetParameterMasterId,
      isundervalidation: flag

    }
    console.log("request before AddCiadxConfig: ", req);

    //  const req = { "usecase_id": "1102310930894880778", "training_data_start_dt": "2024-12-31T18:30:00.000Z", "training_data_end_dt": "2025-04-18T18:30:00.000Z", "forecast_interval": "10", "factoryid": "A_3181", "linemasterid": "61", "skumasterid": "256768", "target_parametermasterid": "2033" };

    return this.networkService.httpReq('post', 'SPCAPICI', 'AddCiadxConfig', req, false);
  }

  // getCimParameterDetails(usecaseid: any, UseCaseConfigId: any, istrue) {
  //   const req: any = {
  //     UseCaseId: usecaseid,
  //     UseCaseConfigId: UseCaseConfigId,
  //     IsAllParams: istrue
  //   };
  //   // const req = {
  //   //   UseCaseId: '1102310930894880778',
  //   //   UseCaseConfigId: '1102311332799774730',
  //   //   IsAllParams: istrue
  //   // }
  //   return this.networkService.httpReq('get', 'SPCAPICI', 'GetCimParameterDetails', req, false);
  // }
  getcimparameterdetails(useCase, useCaseConfigId, istrue) {
    const req: any = {
      UseCaseId: useCase.useCaseId,
      UseCaseConfigId: useCaseConfigId,
      IsAllParams: istrue
    };
    // const req = {
    //   UseCaseId: '1102310930894880778',
    //   UseCaseConfigId: '1102311332799774730',
    //   IsAllParams: istrue
    // }
    return this.networkService.httpReq('get', 'SPCAPICI', 'getcimparameterdetails', req, false);
  }
  updatecimparameterdetails(data: any) {

    return this.networkService.httpReq('put', 'SPCAPICI', 'setparameterchosenstatus', data, false);
  }
  GetTrainingDetail(id: string, configid: string) {
    const data = {
      UseCaseId: id, //'1102310930894880778', 
      UseCaseConfigId: configid
    }
    return this.networkService.httpReq('get', 'SPCAPICI', 'gettrainingviewdetails', data, false);
  }


  UpdateUseCaseModel(data) {
    const payload = data;
    return this.networkService.httpReq('put', 'SPCAPICI', 'setusecasemodelselection', payload, false);
  }
  getusecaseconfigdetail(useCaseId: string) {
    const payload = {
      UsecaseId: useCaseId //'1102310930894880778'
    }
    return this.networkService.httpReq('get', 'SPCAPICI', 'getusecaseconfigdetail', payload, false);
  }

  AddUseCaseModelConfig(payload?: any) {
    return this.networkService.httpReq('post', 'SPCAPICI', 'addusecasecimodel', payload, false);
  }


  getallusecasemodel() {
    let factoryId = this.dataSer.getStorageData('selectedFactory') ?
      JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null;
    const data = { factoryId: factoryId };
    return this.networkService.httpReq('get', 'SPCAPICI', 'getallusecasemodel', data, false);
  }


  deleteUseCaseModel(usecaseid: string, is_deleted) {
    const payload = {
      usecase_id: usecaseid,
      is_deleted: is_deleted
    };
    return this.networkService.httpReq('put', 'SPCAPICI', 'deleteorstopusecase', payload, false);
  }
  restartusecase(usecaseid: string) {
    const payload = {
      usecase_id: usecaseid
    };
    return this.networkService.httpReq('put', 'SPCAPICI', 'restartusecase', payload, false);
  }
  retrainusecase(usecaseid: string) {
    const payload = {
      usecase_id: usecaseid
    };
    return this.networkService.httpReq('post', 'SPCAPICI', 'retrainusecase', payload, false);
  }


  getParametersAll(line) {
    const data: any = {
      factoryname: this.dataSer.getStorageData('selectedFactory') ?
        JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null,
      lineid: line.id
    };
    return this.networkService.httpReq('get', 'SPCAPI', 'GetParameters', data, false);
  }

  getusecasesummarydashboard(rowData?) {
    const data = {
      factory: this.dataSer.getStorageData('selectedFactory') ?
        JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null,
      AreaMasterid: rowData?.AreaMasterid,
      linemasterids: rowData?.linemasterids,
      skumasterids: rowData?.skumasterids
    };
    // const data = {
    //   factory: 'A_3181',
    //   AreaMasterid: '1067437137859674113',
    //   linemasterids: '61',
    //   skumasterids: '256771'
    // };
    return this.networkService.httpReq('get', 'SPCAPICI', 'getusecasesummarydashboard', data, false);
  }
  //https://spcodlapi-dev-aks.df.unilever.com/spcapi/getusecasesummarydashboard?factory=A_3181&AreaMasterid=1067437137859674113&linemasterids=61&skumasterids=256768

  getlinesforcim(rowData?) {
    let data = {};
    if (rowData?.AreaMasterId) {
      data = {
        factoryid: this.dataSer.getStorageData('selectedFactory') ?
          JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null,
        AreaMasterId: rowData?.AreaMasterId,
      };
    } else {
      data = {
        factoryid: this.dataSer.getStorageData('selectedFactory') ?
          JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null,

      };
    }

    return this.networkService.httpReq('get', 'SPCAPICI', 'getlinesforcim', data, false);
  }

  getskuforlines(rowData?) {
    let data = {};
    if (rowData?.AreaMasterId) {
      data = {
        factoryid: this.dataSer.getStorageData('selectedFactory') ?
          JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null,
        areamasterid: rowData?.AreaMasterId,
        skuLineMasterids: rowData?.linemasterIds
      };
    } else {
      data = {
        factoryid: this.dataSer.getStorageData('selectedFactory') ?
          JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null,
        skuLineMasterids: rowData?.linemasterIds
      };
    }
    return this.networkService.httpReq('get', 'SPCAPICI', 'getskuforlines', data, false);
  }

  getusecasedetailedview(usecaseid?) {
    const data = {
      factory: this.dataSer.getStorageData('selectedFactory') ?
        JSON.parse(this.dataSer.getStorageData('selectedFactory')).factoryId : null,
      usecaseid: usecaseid
    };
    if (usecaseid) {
      return this.networkService.httpReq('get', 'SPCAPICI', 'getusecasedetailedview', data, false);
    }
  }

  gethistoricforecastdata(payload) {

    // console.log("After call:", payload);
    return this.networkService.httpReq('get', 'SPCAPICI', 'gethistoricforecastdata', payload, false);

  }

  getmodelperformance(payload) {

    const data = {
      usecasemodelid: payload.usecasemodelid,
      startdate: payload.startdate,
      enddate: payload.enddate
    }

    console.log("BEFORE CALLING API PAYLOAD: ", data)
    return this.networkService.httpReq('get', 'SPCAPICI', 'getmodelperformance', data, false);
  }

  addciEmail(payload) {
    return this.networkService.httpReq('post', 'SPCAPICI', 'emailconfiguration', payload, false);
  }
}


